import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../../assets/styles/cardNews/CardTextOnImage.module.css";
import img from "../../../assets/images/thumbnail_default.jpg";
import RatingIndicator from "../RatingIndicator";
import icon_recommend from "../../../assets/images/ico_recommend.svg";
import PressNDate from "./PressNDate";
import { Obscure } from "../\bobscuredImage";

const CardTextOnImage = ({ news }) => {
  const navigate = useNavigate();
  const moveToSingleNews = () => {
    navigate(`/single-news/${news.newsid}`);
  };
  const moveToTimeline = () => {
    navigate(`/${news.newsid}/timeline`);
  };

  return (
    <div className={styles.card_container}>
      {news && (
        <>
          <div style={{ position: "absolute", top: "16px", left: "16px" }}>
            <RatingIndicator
              className="icon_recommend"
              signal={news.signal}
              percent={news.staticsentimental.percent}
            />
          </div>
          <Obscure text={news?.press}>
            <img
              className={styles.thumbnail}
              src={news.imgsrc || img}
              alt={news.subject}
              onClick={moveToSingleNews}
            />
          </Obscure>
          <div className={styles.card_content_bg}>
            <div className={styles.card_content}>
              <span className={styles.stockname}>{news.stockname}</span>
              <p className={styles.title}>{news.subject}</p>
              <div className={styles.card_footer}>
                {/*<span>{news.press}·{news.registdate}</span>*/}
                <PressNDate press={news.press} date={news.registdate} />
                {news.samenewscounts > 0 && (
                  <span className={styles.newscnt} onClick={moveToTimeline}>
                    연관뉴스 {news.samenewscounts}건 보기 >{" "}
                  </span>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CardTextOnImage;
